const meeting = {
  'queue': 'Kolejka',
  'visit': 'Wizyta',
  'do-you-want-sign-up-for-visit': 'Czy na pewno chcesz zapisać się na wybraną wizytę?',
  'do-you-want-cancel-visit': 'Czy na pewno chcesz anulować wizytę?',
  'available-visits': 'Dostępne wizyty',
  'term-for-hour': 'Termin na godzinę',
  'select-queue-for-specific-day': 'Wybierz dostępny dzień dla kolejki: ',
  'localization': 'Lokalizacja',
  'term': 'Termin',
  'choose-queue': 'Wybierz kolejkę aby zobaczyć dostępne terminy',
  'name': 'Nazwa kolejki',
  'start-date': 'Data początkowa',
  'start-time': 'Godzina początkowa',
  'duration-of-slot': 'Czas trwania jednej wizyty',
  'number-of-slots': 'Liczba wizyt',
  'break-between-slots': 'Przerwa pomiędzy wizytami',
  'add-new-queue': 'Dodaj nową kolejkę',
  'day': 'Dzień',
  onlyOneSlot: 'W tej kolejce można zajmować tylko jedno miejsce.',
  manySlot: 'W tej kolejce można zajmować wiele miejsc.',
  noSlotsAdmin: 'Ta kolejka nie ma żadnych wolnych miejsc. Dodaj nowe!',
  noSlots: 'Wszystkie miejsca w kolejce są obecnie zajęte.',
  presenceReports: {
    header: 'Więcej opcji',
    noResults: 'Nie znaleziono żadnych zajętych slotów dla podanych parametrów.',
    errors: {
      forbiddenQueue: 'Nie masz dostępu do żadnej kolejki!',
      export: 'Wystąpił błąd podczas generowania pliku!',
      general: 'Wystąpił nieoczekiwany błąd'
    },
    report: {
      headers: {
        name: 'Imię',
        surname: 'Nazwisko',
        index: 'Indeks',
        unitName: 'Nazwa wydziału',
        unit: 'Wydział',
        end_of_studies: 'Zakończenie studiów',
        date: 'Data',
        hour: 'Godzina'
      },
      deltaTime: 'Przedział czasu',
      startDate: 'Data początku',
      endDate: 'Data końca',
      shortcuts: {
        header: 'Skróty',
        options: {
          today: 'Dzisiaj',
          thisWeek: 'Ten tydzień',
          thisMonth: 'Ten miesiąc',
          everything: 'Wszystko'
        }
      },
      export: {
        header: 'Eksport',
        info1: 'Generowanie raportu w formacie',
        info2: 'To może zająć kilka minut.',
        info3: 'Gotowe!',
        types: {
          csv: 'CSV'
        },
        button: 'Generuj'
      }
    }
  }
};

export default meeting;
